import themes from '../../theming/themes.js';
import React from 'react';

var ModalContext = /*#__PURE__*/React.createContext({
  containerMaxHeight: '100%',
  contentMaxHeight: '2000px',
  disabledBackdropClick: false,
  footerPrimaryButtonText: 'Okay',
  footerSecondaryButtonText: 'Cancel',
  hasCloseIcon: false,
  headerText: 'Test Modal',
  headerComponent: /*#__PURE__*/React.createElement(React.Fragment, null),
  hideModal: function hideModal() {},
  isOpen: false,
  openButtonText: 'Open Modal',
  setIsOpen: function setIsOpen() {},
  showModal: function showModal() {},
  size: 'medium',
  theme: themes["default"]
});

export { ModalContext };
